import React, { useEffect, useState } from "react";
import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import { Link, useNavigate } from "react-router-dom";
import { BEST_PERFORMANCE_SCHOOL_API } from "../Component/AllApi";
import Loader from "./Loader";
const BestPerformingSchoolList = () => {
  const token = localStorage.getItem("authToken");
  const [schools, setSchools] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const navigate = useNavigate();
  // eslint-disable
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        let response = await fetch(BEST_PERFORMANCE_SCHOOL_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (response.ok) {
          const responseData = await response.json();
          // console.log("data: ", responseData);
          setSchools(responseData.allSchools);
        }
      } catch (err) {
        console.error("Error occured ", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // console.log("best is loading", isLoading);

  if (isLoading === "true") {
    localStorage.setItem("isLoading", true);
  } else {
    localStorage.setItem("isLoading", false);
  }
  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
  };

  const sortedData = sortBy
    ? schools.slice(0, 5).sort((a, b) => {
        const keyA = a[sortBy];
        const keyB = b[sortBy];
        if (sortDirection === "asc") {
          return keyA.localeCompare(keyB);
        } else {
          return keyB.localeCompare(keyA);
        }
      })
    : schools.slice(0, 5);

  const handleViewAll = () => {
    navigate("/schools");
  };
  // console.log("Schools: ", schools);
  return (
    <>
      <section className="bestSchools mb-5">
        <div className="row mt-5">
          <div className="col-lg-8">
            <p className="main_title"> Best Performing School List</p>
          </div>
          {/* <div className="col-lg-4">
            <button className="viewAllBtn btn" onClick={handleViewAll}>
              View All
            </button>
          </div> */}
        </div>
        <div className="backgroundDiv">
          <table className="table table-borderless">
            <thead>
              <tr>
                <th scope="col">Sr No.</th>
                <th
                  scope="col"
                  onClick={() => handleSort("school_name")}
                  style={{ cursor: "pointer" }}
                >
                  School Name
                  <img
                    className="desc ms-1"
                    src={
                      sortDirection === "asc" && sortBy === "school_name"
                        ? downArrow
                        : upArrow
                    }
                    alt="Sort Button"
                  />
                </th>
                <th
                  scope="col"
                  onClick={() => handleSort("trainer_name")}
                  style={{ cursor: "pointer" }}
                >
                  Teacher
                  <img
                    className="desc ms-1"
                    src={
                      sortDirection === "asc" && sortBy === "trainer_name"
                        ? downArrow
                        : upArrow
                    }
                    alt="Sort Button"
                  />
                </th>
                <th scope="col">Videos Watched</th>
                <th scope="col">Videos Remaining</th>
                <th scope="col">Time Spent</th>
                <th scope="col">Progress</th>
              </tr>
            </thead>
            <div className="mt-3"></div>
            <tbody>
              {sortedData &&
                sortedData.length > 0 &&
                sortedData.map((data, index) => (
                  <tr key={index}>
                    <td style={{ paddingBottom: "20px" }}>
                      <span className="srNo">{index + 1}</span>
                    </td>
                    <td>{data.school_name}</td>
                    <td>
                      <Link
                        to="/teacherParticularData"
                        style={{ textDecoration: "none" }}
                        onClick={() => {
                          localStorage.setItem("trainer_id", data.trainer_id);
                          localStorage.setItem(
                            "trainer_name",
                            data.trainer_name
                          );
                        }}
                        state={{
                          trainerId: data.trainer_id,
                          trainerName: data.trainer_name,
                          referrer: "/dashboard",
                        }}
                        className="ms-2"
                      >
                        {data.trainer_name === "Unallocated" ? (
                          <span className="school_teacher_name">
                            {data.trainer_name}
                          </span>
                        ) : (
                          <span className="allocatedTeacher">
                            {data.trainer_name}
                          </span>
                        )}
                      </Link>
                    </td>

                    <td className="ps-5">{data.vid_watched}</td>
                    <td className="ps-5">{data.vid_remaining}</td>
                    <td>{data.time_spent}</td>
                    <td className="ps-4">{data?.vid_percentage ? data?.vid_percentage : 0} %</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default BestPerformingSchoolList;
